import React, { useState, useEffect } from 'react';
import { getNotificacoes, atenderNotificacao } from '../services/api';

function formatarData(d) {
    if (!d) return '—';
    return new Date(d).toLocaleString('pt-BR');
}

const TIPO_CONFIG = {
    panico:     { label: 'Pânico',            cor: '#ff3b30', bg: 'rgba(255,59,48,0.1)',    icone: '🆘' },
    velocidade: { label: 'Excesso de Vel.',   cor: '#ff9500', bg: 'rgba(255,149,0,0.1)',    icone: '⚡' },
};

function getTipo(tipo) {
    return TIPO_CONFIG[tipo] || { label: tipo, cor: '#636366', bg: 'rgba(99,99,102,0.1)', icone: '⚠️' };
}

function ModalAtender({ notificacao, onSalvar, onFechar }) {
    const [obs, setObs] = useState('');
    const [salvando, setSalvando] = useState(false);

    const salvar = async () => {
        setSalvando(true);
        try {
            await atenderNotificacao(notificacao.id, obs);
            onSalvar();
        } finally { setSalvando(false); }
    };

    const cfg = getTipo(notificacao.tipo);

    return (
        <div className="ios-overlay" onClick={onFechar} style={{ zIndex: 4100 }}>
            <div className="ios-sheet" style={{ width: 420, maxWidth: '95vw' }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--ios-separator)' }}>
                    <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#ff3b30', fontSize: 15, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>Cancelar</button>
                    <span style={{ fontWeight: 600, fontSize: 16 }}>Atender Ocorrência</span>
                    <button onClick={salvar} disabled={salvando} style={{ background: 'none', border: 'none', color: '#007aff', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--ios-font)' }}>
                        {salvando ? '...' : 'Confirmar'}
                    </button>
                </div>

                <div style={{ padding: '20px 20px', background: 'var(--ios-gray6)' }}>
                    {/* Info da notificação */}
                    <div style={{ background: 'white', borderRadius: 12, padding: '14px 16px', marginBottom: 16, boxShadow: 'var(--ios-shadow)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                            <span style={{ fontSize: 22 }}>{cfg.icone}</span>
                            <div>
                                <div style={{ fontWeight: 600, fontSize: 15, color: cfg.cor }}>{cfg.label}</div>
                                <div style={{ fontSize: 12, color: 'var(--ios-gray)' }}>{notificacao.veiculo_nome} — {notificacao.placa}</div>
                            </div>
                        </div>
                        <div style={{ fontSize: 13, color: 'var(--ios-label)', marginBottom: 6 }}>{notificacao.descricao}</div>
                        <div style={{ fontSize: 12, color: 'var(--ios-gray)' }}>{formatarData(notificacao.data_evento)}</div>
                        {notificacao.latitude && (
                            <a
                                href={`https://www.google.com/maps?q=${notificacao.latitude},${notificacao.longitude}`}
                                target="_blank" rel="noreferrer"
                                style={{ fontSize: 12, color: '#007aff', display: 'inline-block', marginTop: 6 }}
                            >
                                Ver no mapa ↗
                            </a>
                        )}
                    </div>

                    {/* Observação */}
                    <div style={{ background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: 'var(--ios-shadow)' }}>
                        <div style={{ padding: '0 16px' }}>
                            <span style={{ fontSize: 11, color: 'var(--ios-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', paddingTop: 9 }}>
                                Observação / Tratativa
                            </span>
                            <textarea
                                value={obs}
                                onChange={e => setObs(e.target.value)}
                                placeholder="Descreva o que foi feito (ex: Contatei o motorista, situação normalizada)..."
                                rows={4}
                                style={{
                                    width: '100%', border: 'none', outline: 'none', fontSize: 14, resize: 'vertical',
                                    fontFamily: 'var(--ios-font)', color: 'var(--ios-label)',
                                    background: 'transparent', padding: '8px 0 12px', boxSizing: 'border-box',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function Notificacoes({ onFechar }) {
    const [notificacoes, setNotificacoes] = useState([]);
    const [filtro, setFiltro] = useState('pendentes');
    const [atendendo, setAtendendo] = useState(null);
    const [carregando, setCarregando] = useState(true);

    const carregar = async () => {
        try {
            const res = await getNotificacoes(filtro === 'pendentes');
            setNotificacoes(res.data);
        } catch(e) {} finally { setCarregando(false); }
    };

    useEffect(() => { carregar(); }, [filtro]);

    const pendentes = notificacoes.filter(n => !n.atendida).length;

    return (
        <div className="ios-overlay" onClick={onFechar} style={{ zIndex: 4000 }}>
            <div className="ios-sheet" style={{ width: 700, maxWidth: '96vw', maxHeight: '88vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--ios-separator)', flexShrink: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ fontWeight: 600, fontSize: 17 }}>Notificações</span>
                        {pendentes > 0 && (
                            <span style={{ background: '#ff3b30', color: 'white', borderRadius: 20, padding: '2px 9px', fontSize: 12, fontWeight: 700 }}>
                                {pendentes} pendente{pendentes > 1 ? 's' : ''}
                            </span>
                        )}
                    </div>
                    <button className="ios-btn ios-btn-gray ios-btn-sm" onClick={onFechar}>Fechar</button>
                </div>

                {/* Filtro */}
                <div style={{ display: 'flex', gap: 0, borderBottom: '1px solid var(--ios-separator)', flexShrink: 0, background: 'var(--ios-gray6)' }}>
                    {[{ key: 'pendentes', label: 'Pendentes' }, { key: 'todas', label: 'Todas' }].map(f => (
                        <div key={f.key} onClick={() => setFiltro(f.key)} style={{
                            padding: '12px 20px', cursor: 'pointer', fontSize: 13, fontWeight: 500,
                            color: filtro === f.key ? '#007aff' : 'var(--ios-gray)',
                            borderBottom: filtro === f.key ? '2px solid #007aff' : '2px solid transparent',
                            transition: 'all 0.15s',
                        }}>
                            {f.label}
                        </div>
                    ))}
                </div>

                {/* Lista */}
                <div style={{ flex: 1, overflowY: 'auto', padding: 16, background: 'var(--ios-gray6)' }}>
                    {carregando ? (
                        <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 40 }}>Carregando...</div>
                    ) : notificacoes.length === 0 ? (
                        <div style={{ textAlign: 'center', color: 'var(--ios-gray)', padding: 60 }}>
                            <div style={{ fontSize: 40, opacity: 0.3, marginBottom: 10 }}>🔔</div>
                            <div style={{ fontSize: 15, fontWeight: 500 }}>
                                {filtro === 'pendentes' ? 'Nenhuma notificação pendente' : 'Nenhuma notificação registrada'}
                            </div>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            {notificacoes.map(n => {
                                const cfg = getTipo(n.tipo);
                                return (
                                    <div key={n.id} style={{
                                        background: 'white', borderRadius: 12, padding: '14px 16px',
                                        boxShadow: 'var(--ios-shadow)',
                                        borderLeft: `4px solid ${n.atendida ? '#34c759' : cfg.cor}`,
                                        opacity: n.atendida ? 0.75 : 1,
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                                            <span style={{ fontSize: 24, flexShrink: 0 }}>{cfg.icone}</span>
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
                                                    <span style={{ fontWeight: 600, fontSize: 14, color: cfg.cor }}>{cfg.label}</span>
                                                    <span style={{ fontSize: 13, color: 'var(--ios-label)', fontWeight: 500 }}>{n.veiculo_nome} — {n.placa}</span>
                                                    {n.atendida && (
                                                        <span style={{ background: 'rgba(52,199,89,0.12)', color: '#34c759', borderRadius: 20, padding: '2px 9px', fontSize: 11, fontWeight: 600 }}>
                                                            Atendida
                                                        </span>
                                                    )}
                                                </div>
                                                <div style={{ fontSize: 13, color: 'var(--ios-label2)', marginBottom: 4 }}>{n.descricao}</div>
                                                <div style={{ fontSize: 12, color: 'var(--ios-gray)' }}>{formatarData(n.data_evento)}</div>
                                                {n.atendida && n.observacao && (
                                                    <div style={{ marginTop: 8, background: 'var(--ios-gray6)', borderRadius: 8, padding: '8px 10px', fontSize: 12, color: 'var(--ios-label2)' }}>
                                                        <strong>Tratativa:</strong> {n.observacao}
                                                        <span style={{ color: 'var(--ios-gray)', marginLeft: 8 }}>— {n.atendida_por}, {formatarData(n.atendida_em)}</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0, alignItems: 'flex-end' }}>
                                                {n.latitude && (
                                                    <a href={`https://www.google.com/maps?q=${n.latitude},${n.longitude}`} target="_blank" rel="noreferrer"
                                                        style={{ fontSize: 11, color: '#007aff', textDecoration: 'none' }}>
                                                        Mapa ↗
                                                    </a>
                                                )}
                                                {!n.atendida && (
                                                    <button className="ios-btn ios-btn-primary ios-btn-sm" onClick={() => setAtendendo(n)}>
                                                        Atender
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>

            {atendendo && (
                <ModalAtender
                    notificacao={atendendo}
                    onSalvar={() => { setAtendendo(null); carregar(); }}
                    onFechar={() => setAtendendo(null)}
                />
            )}
        </div>
    );
}
